import type { UiStrings } from '@/constants/ui-locale'

/**
 * Maps a language code to its localized display name for UI labels (e.g. the
 * create-meeting language pickers). `LANGUAGES[].name` itself stays in
 * English on purpose — it's also sent to the AI analysis API as a plain
 * English language name, so it can't be swapped to the active UI locale.
 */
export function getLanguageDisplayName(code: string, t: UiStrings): string {
  switch (code) {
    case '':
      return t.autoDetect
    case 'en':
      return t.languageEnglish
    case 'ja':
      return t.languageJapanese
    case 'vi':
      return t.languageVietnamese
    default:
      return code
  }
}
